import { message, notification } from "antd";

export default function shareTourLink() {
  const url = new URL(window.location.href);
  url.searchParams.delete("ref");
  url.searchParams.delete("keyword");

  if (!navigator.clipboard) {
    notification.error({ message: "Unable to copy link. Please copy the URL from your browser." });
    return;
  }

  navigator.clipboard.writeText(url.toString()).then(() => {
    message.success("Tour link is ready to be shared to your friends and family");
  }).catch(() => {
    notification.error({ message: "Unable to copy link. Please copy the URL from your browser." });
  });
}
